module.exports = __webpack_public_path__ + "static/mapLocation3-daa225fbe1b8fd02fc26ced46c990e11.png";